import { ModelBase } from '../../models/abstract/model-base.model';

export class TreeNode extends ModelBase {

    private _children!: any[];
    private _count!: number;
    private _key: any;
    private _label!: string;
    private _level!: number;
    private _nodes: TreeNode[] = [];
    private _open: boolean = false;
    private _parent!: TreeNode;

    constructor(data: any) {
        super(data);
        this._nodes = !!this._nodes ? this._nodes : [];
        this._open = !!this._open;
    }

    public get children() {
        return this._children;
    }

    public set children(value: any[]) {
        this._setValue('_children', value, 'any');
    }

    public get count() {
        return this._count;
    }

    public set count(value: any) {
        this._setValue('_count', value, 'integer');
    }

    public get key() {
        return this._key;
    }

    public set key(value: any) {
        this._setValue('_key', value, 'any');
    }

    public get label() {
        return this._label;
    }

    public set label(value: any) {
        this._setValue('_label', value, 'string');
    }

    public get level() {
        return this._level;
    }

    public set level(value: any) {
        this._setValue('_level', value, 'integer');
    }

    public get nodes() {
        return this._nodes;
    }

    public set nodes(value: any[]) {
        this._setValue('_nodes', value, 'TreeNode');
    }

    public get open() {
        return this._open;
    }

    public set open(value: any) {
        this._setValue('_open', value, 'boolean');
    }

    public get parent() {
        return this._parent;
    }

    public set parent(value: any) {
        this._parent = value;
    }
}
